module.exports = __webpack_public_path__ + "img/ИФ-1(А)-022-m.11feac8c.png";